<template>
  <div class="research_group_container">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">进展详情</span>
    </div>
    <div class="box">
      <div class="bd">
        <div class="group_2">
          <div class="group">
            <span class="firstStage" :lines="undefined">{{stage.stageName}}：</span>
            <span class="preExperiment" :lines="undefined">{{project.projectName}}</span>
          </div>
          <span class="colorDiv_2 color_greeen" v-show="project.status==='结束'||project.status==='终止'">已完成</span>
          <span class="colorDiv_2 color_red" v-show="project.status==='未开始'">未开始</span>
          <span class="colorDiv_2 color_orange" v-show="project.status==='进行中'">进行中</span>
        </div>
        <div class="empty" />
        <task-progress :type="type" :subType="subType" :taskModules="project.taskProgresses" :expressOutList="expressOutList"></task-progress>
      </div>
    </div>
  </div>
</template>

<script>
  import TaskProgress from './TaskProgress'
  import EMKT from '../../../../emkt'
  export default {
    name: 'ServiceTaskProgress',
    data () {
      return {
        isShow: false,
        stage: {},
        project: {},
        type: 'Service',
        subType: true,
        expressOutList: [],
        isWapp: EMKT.isWapp
      }
    },
    components: {
      TaskProgress
    },
    mounted () {
      this.stage = this.$route.query.stage
      this.project = this.$route.query.project
      this.expressOutList = JSON.parse(this.$route.query.expressOutList)
    },
    methods: {
      goBack () {
        this.$router.push({name: 'Progress', query: {item: EMKT.getLocalStorage('chosenItem')}})
        // this.$router.go(-1)
      },
      changeShow: function (status) {
        this.isShow = status
      }
    }
  }
</script>

<style scoped>
  .research_group_container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100%;
  }

  .navshare {
    position: absolute;
    left: 6.67vw;
    width: 10vw;
    height: 10vw;
    padding-top: 2vw;
    color:#ffffff;
  }

  .header_title {
    opacity: 1;
    /*margin-left: 29.33vw;*/
    max-width: 60.53vw;
    height: 5.87vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.87vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 4.27vw;
    font-weight: 400;
  }



  .hd {
    display: flex;
    position: fixed;
    top:0;
    left:0;
    align-items: center;
    flex-direction: row;
    /*background-color: #5878fa;*/
    width: 100vw;
    height: 14.93vw;
    z-index: 10;
    justify-content: center;
  }

  .box {
    display: flex;
    flex-shrink: 0;
    position: relative;
    align-items: center;
    flex-direction: column;
    background-color: #FAFAFA;
    width: 100vw;
    height: 97vh;
    top: 14.93vw;
    bottom: 4vw;
  }
  .bd {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 2.67vw;
    border-width: 1px;
    border-style: solid;
    border-radius: 2.67vw;
    border-color: rgba(239, 238, 243, 1);
    background-color: #ffffff;
    width: 94.67vw;
  }

  .progress1 {
    margin-left: 4vw;
    margin-top: 1.77vh;
    height: 18vh;
    position: relative;
  }
  .leftDiv {
    position: relative;
    height: 15.8vw;
  }
  .left1 {
    position: absolute;
    z-index: 9;
  }
  .div {
    position: absolute;
    top: 2.67vw;
    left: 1.33vw;
    border-left-width: 2px;
    border-left-style: solid;
    border-left-color: rgba(88, 120, 250, 1);
    width: 0.8vw;
    height: 17.8vw;
    z-index: 1;
  }

  .block_3 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: -28.27vw;
    margin-left: 6.4vw;
    width: 77.27vw;
    height: 28.6vw;
  }

  .plasmidExtraction {
    opacity: 1;
    max-width: 42.4vw;
    height: 5.33vw;
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    line-height: 5.33vw;
    /*white-space: nowrap;*/
    color: #424242;
    font-size: 3.73vw;
    font-weight: 500;
  }

  .outer_2 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 5.33vw;
  }

  .completionTime {
    opacity: 1;
    margin-right: 2.67vw;
    max-width: 20.8vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }
  .colorDiv_2 {
    position: absolute;
    top: 0vw;
    right: 4vw;
    border-radius: 1.87vw;
    width: 10.67vw;
    height: 3.73vw;
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #ffffff;
    font-weight: 400;
    font-size: 2.74vw;
    line-height: 4.23vw;
  }
  .color_greeen {
    background-color: #60d837;
  }
  .color_orange{
    background-color: #ff9400;
  }
  .text_0 {
    display: inline-block;
    font-size: 2.74vw;
    position: relative;
    top:-0.80vw;
    left: 0.20vw;
    transform: scale(0.8);
    color: white;
  }
  .group_2 {
    display: flex;
    flex-shrink: 0;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 3.2vw;
    margin-left: 3.73vw;
    width: 84.8vw;
    height: 5.6vw;
  }

  .group {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 5.33vw;
  }

  .firstStage {
    opacity: 1;
    margin-right: 1.33vw;
    max-width: 32.27vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.73vw;
    font-weight: 500;
  }

  .preExperiment {
    opacity: 1;
    max-width: 50.53vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.73vw;
    font-weight: 400;
  }

  .empty {
    position: relative;
    margin-top: 2.4vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .text {
    opacity: 1;
    max-width: 31.2vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }
  .container_4 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: -9.67vw;
    border-width: 1px;
    border-style: solid;
    border-radius: 2.93vw;
    /*border-color: rgba(151, 151, 151, 1);*/
    border-color:  #5878fa;
    width: 28.53vw;
    height: 6.13vw;
    margin-left: 6vw;
    padding-left: 2vw;
  }
  .info_2 {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }


  .bg {
    display: flex;
    position: absolute;
    flex-shrink: 0;
    align-items: center;
    flex-direction: row;
    width: 100vw;
    height: 216.53vw;
    top: 0;
    background-color: lightgray;
    opacity: 0.5;
    z-index: 10;
  }
  .container1 {
    display: flex;
    position: fixed;
    top: 50vw;
    left: 13.33vw;
    align-items: center;
    flex-direction: column;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 73.33vw;
    height: 62.4vw;
    z-index: 11;
    opacity: 1!important;
  }
  .summary1 {
    webkit-line-clamp: 3px;
    position: relative;
    opacity: 1;
    margin-top: 7.73vw;
    width: 57.6vw;
    height: 27.2vw;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    line-height: 9.07vw;
    color: #424242;
    font-size: 4.8vw;
    font-weight: 500;
  }

  .outer1 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 7.47vw;
    width: 60vw;
    height: 13.33vw;
  }

  .tagWrap1 {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-radius: 2.67vw;
    background-color: #eeeeee;
    padding-right: 9.6vw;
    padding-left: 9.6vw;
    height: 13.33vw;
  }

  .tag1{
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.73vw;
    font-weight: 400;
  }

  .tagWrap_21 {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-radius: 2.67vw;
    background-color: #5878fa;
    padding-right: 9.6vw;
    padding-left: 9.6vw;
    height: 13.33vw;
  }

  .tag_21 {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 3.73vw;
    font-weight: 400;
  }


</style>



// WEBPACK FOOTER //
// ServiceTaskProgress.vue?772c861b